import { TMessageSchema } from '../../../types/messages';
import { IParsedMessage } from '../../../utils/messageUtils';

export function updateDeletedQuote(replyMessage: IParsedMessage, originalMessage: TMessageSchema): IParsedMessage {
  const { reply: currentReply } = replyMessage.message;

  if (!currentReply) {
    return replyMessage;
  }

  return {
    ...replyMessage,
    message: {
      ...replyMessage.message,
      reply: {
        type: 'deleted',
        messageId: originalMessage.messageId,
        authorId: currentReply.authorId,
        quoteText: originalMessage.text || '',
      },
    },
  };
}

export function updateRestoredQuote(replyMessage: IParsedMessage): IParsedMessage {
  const { reply: currentReply } = replyMessage.message;

  if (!currentReply) {
    return replyMessage;
  }

  return {
    ...replyMessage,
    message: {
      ...replyMessage.message,
      reply: replyMessage.rawMessage.reply ?? null,
    },
  };
}
